import { DeepPartial, TrackAddToCartConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_TRACK_ADD2CART_CONFIG: DeepPartial<TrackAddToCartConfig> = {
  buttonsSelector: '.btn-cart',
  storage: {
    resultKeyField: 'mpn'
  }
};
